export default "__VITE_ASSET__0c5ada4d__"